<template>
	<div class="container">
		<div
			v-for="(item, index) in EtfGridData.slice(0.6)"
			:key="index"
			class="container_item"
			@click="onClickCard(item.title)"
		>
			<component :is="item.icon" />
			<div class="container_item_content">
				<span class="content_title">{{ item.title }}</span>
				<div class="content_sub">
					<p>{{ item.top_sub }}<br />{{ item.bottom_sub && item.bottom_sub }}</p>
				</div>
			</div>
		</div>
	</div>
</template>
<script setup lang="ts">
import { EtfGridData } from '@/constants/menu';

// -----variable-----
const emit = defineEmits(['upload:item']);

// -----function-----
const onClickCard = (item: string) => {
	emit('upload:item', item);
};
</script>

<style lang="scss" scoped>
.container {
	display: grid;
	grid-template-columns: repeat(2, 1fr);
	gap: 1rem;
}
.container_item {
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 1rem;
	padding: 1.6rem;
	background-color: var(--color-bg-mid);
	border-radius: var(--border-radius-small);
	cursor: pointer;
	&_content {
		display: flex;
		flex-direction: column;
		align-items: center;
		gap: 0.4rem;
		.content_title {
			font-size: var(--font-s-mid);
			font-weight: var(--font-w-semi-bold);
			line-height: normal;
		}
		.content_sub {
			text-align: center;
			font-size: var(--font-s-small);
			font-weight: var(--font-w-light);
			color: var(--color-base-light);
			line-height: normal;
			// br 태그 숨김
			@media (max-width: 359px) {
				br {
					display: none;
				}
			}
		}
	}
}
</style>
